
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"49","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.043 31.075v-1.074h3.062V29.9c-.99-.584-1.745-1.349-2.27-2.295-.524-.95-.788-2.07-.792-3.362 0-.942.138-1.805.415-2.589a6.285 6.285 0 011.176-2.039 5.332 5.332 0 011.79-1.336 5.381 5.381 0 012.263-.473c.818 0 1.57.158 2.256.473.69.316 1.287.761 1.79 1.336.507.575.9 1.257 1.176 2.046.281.784.422 1.645.422 2.582-.004 1.287-.268 2.406-.793 3.356-.524.95-1.28 1.717-2.269 2.301v.102h3.062v1.074h-4.474v-1.387a5.76 5.76 0 002.864-3.023c.298-.716.447-1.522.447-2.416.004-.993-.186-1.89-.57-2.692-.378-.805-.907-1.444-1.584-1.917-.674-.473-1.45-.71-2.327-.71-.66 0-1.266.137-1.816.41a4.341 4.341 0 00-1.418 1.137 5.29 5.29 0 00-.921 1.688 6.473 6.473 0 00-.326 2.084c-.004.894.143 1.7.441 2.416a5.85 5.85 0 001.208 1.834 5.849 5.849 0 001.662 1.19v1.386h-4.474z","fill":"currentColor"}})])
          )
        }
      }
    